import { init as initNavbar } from "app/utils/navbar";

const init = () => {

    const charts = document.getElementById("chartContainer-total");
    const movements = document.getElementById("movements");
    const root = document.getElementById("root");
    if (charts) {
        initNavbar();
        let charts = import(/* webpackChunkName: "charts" */ 'app/categories/categoriesCharts');
        let moment = import(/* webpackChunkName: "moment" */ 'moment');
        Promise.all([charts, moment]).then(([charts, moment]) => {
            charts.createAllCharts(yearExpensesPie, yearIncomePie, totalExpensesByMonth, totalIncomeByMonth, expensesByMonthSum, incomeByMonthSum,
                expensesCategories, incomeCategories, months, totalByDayMonth);
        });
    } else if (movements) {
        initNavbar();
        import(/* webpackChunkName: "movements" */ "app/movements/movementsTable").then(m => {
            m.init();
        });
    } else if (root) {
        if (import.meta.webpackHot) {
            import.meta.webpackHot.accept("app/react/index", () => {
                console.log("🔄 Hot reloaded App module");
            });
        }

        import(/* webpackChunkName: "transactions" */ "app/react/index").then(m => {
            m.init(root);
        });
    }
};

document.addEventListener('DOMContentLoaded', init);
